/* Modules */
import axios from "axios";

/* Settings */
import { Eprezto_Settings } from "../settings";

let API_URL = "";

if (Eprezto_Settings.DEVELOPMENT_MODE) {
  /* API_URL = "http://localhost:3001/auth/car_workshop_login"; */
  API_URL = "https://apollo.eprezto.com/auth/car_workshop_login";
} else {
  API_URL = "https://apollo.eprezto.com/auth/car_workshop_login";
}

export const getUserProfile = async () => {
  console.log("getUserProfile exec");

  try {
    let data = await axios.get(`${API_URL}/user-profile`, {
      withCredentials: true,
    });

    console.log("getUserProfile response:", data.data);

    return data.data;
  } catch (e) {
    console.log("error", e);
  }
};

export const getUserSession = async () => {
  console.log("getUserSession exec");

  try {
    let data = await axios.get(`${API_URL}/get-user-session`, {
      withCredentials: true,
    });

    console.log("getUserSession response:", data.data);

    return data.data;
  } catch (e) {
    console.log("error", e);
  }
};


export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}